import React from 'react'
import styles from '../styles/aboutcomponent.module.css';
import Sewing_machine from '../../../assets/about/projects/training-centre-480x361.jpeg';
import Physics_chem_lab from '../../../assets/about/projects/IMG_3932-1-480x270.jpeg';
import Container_classroom from '../../../assets/about/projects/Container-classroom-480x361.jpeg';
import Art_and_craft from '../../../assets/about/projects/IMG_4129-1-300x225.jpeg';
import Container_Lib from '../../../assets/about/projects/container_lib.jpg';
import todofodolab from '../../../assets/about/projects/image_038.jpeg';
import Music_room from '../../../assets/about/projects/IMG_4128-1-2048x1536.jpeg';
import Computer_lab from '../../../assets/about/projects/Computer-Lab-1-300x200.jpg';
import HairAndBEutyGrooming from '../../../assets/about/projects/image_043.jpeg';


const Facilities = () => {
  return (
    <div className={styles.about_component}>
              {/* ================= FACILITIES ================= */}
        <div id="facilities" className={styles.sectionAnchor}>
          <h2>OUR FACILITIES</h2>

          <div className={styles.about_container}>
            <div>
              <h4>The Container Classrooms: Havens of Global Knowledge</h4>
              <p>
                Our two state-of-the-art, purpose-built Container Classrooms
                are meticulously equipped with modern desks, chairs, and
                whiteboards — spaces that, through passionate volunteers from
                across the world, become vibrant hubs of global cultural
                exchange.
              </p>
            </div>
            <div>
              <img src={Container_classroom} alt="Container classroom" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Container Library</h4>
              <p>
                Adorned with 15,000 books, a generous gift from the Bookwallah
                Organization in Chicago, this exceptional library — the first
                of its kind in India — serves as a cultural bridge through
                literature and language exploration.
              </p>
            </div>
            <div>
              <img src={Container_Lib} alt="Container Library" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The 'Todo Phodo' (Dismantle &amp; Discover) Lab</h4>
              <p>
                In this practical hardware laboratory, students take things
                apart — completely opening up computers and electronics to
                learn how they work from the inside out, transforming
                curiosity into technical mastery.
              </p>
            </div>
            <div>
              <img src={todofodolab} alt="Container Library" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Dr. Mashelkar Science Innovation Center</h4>
              <p>
                Equipped with cutting-edge instruments, students engage in
                rigorous, hands-on experiments across mechanics, optics, and
                chemistry, experiencing the thrill of discovery in a safe,
                immersive environment.
              </p>
            </div>
            <div>
              <img src={Physics_chem_lab} alt="Science Innovation Center" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Computer Lab</h4>
              <p>
                A gateway to the contemporary world, empowering children with
                essential digital literacy through customized lessons in
                software programs and a diverse array of academic and personal
                applications.
              </p>
            </div>
            <div>
              <img src={Computer_lab} alt="Computer Lab" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Soulful Symphony: Music Room</h4>
              <p>
                A vibrant sanctuary where melody comes alive. Under the
                guidance of Ashok's father and dedicated instructors, children
                receive vocal coaching and instrumental training in tabla and
                harmonium, performing Bhavgeets, Abhangas, and Goulans.
              </p>
            </div>
            <div>
              <img src={Music_room} alt="Music Room" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>The Limitless Canvas: Art &amp; Craft Maker-Space</h4>
              <p>
                A true interdisciplinary maker-space offering a massive
                spectrum of artistic mediums — from traditional painting
                supplies to the practical tools of carpentry, masonry, and
                electrical crafts.
              </p>
            </div>
            <div>
              <img src={Art_and_craft} alt="Art and Craft" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Hair &amp; Beauty Grooming Studio</h4>
              <p>
                Children learn the practical art of personal grooming — hair
                cutting and professional styling techniques — acquiring a
                valuable skill that fosters independence and self-esteem.
              </p>
            </div>
            <div>
              <img src={HairAndBEutyGrooming} alt="Art and Craft" loading="lazy" />
            </div>
          </div>
        </div>
    </div>
  )
}

export default Facilities